import { useEffect, useState } from "react";
import ClientTable from "../../components/clients/ClientTable";
import ClientForm from "../../components/clients/ClientForm";

import {
  getClients,
  createClient,
  updateClient,
  deleteClient
} from "../../api/clients.api";


export default function ClientsPage() {

  const [clients, setClients] = useState([]);
  const [clientEdit, setClientEdit] = useState(null);
  const [formOpen, setFormOpen] = useState(false);


  // Chargement des clients au démarrage
  useEffect(() => {
    loadClients();
  }, []);


  // Récupérer les clients
  const loadClients = async () => {
    try {
      const res = await getClients();
      setClients(res.data);

    } catch (error) {
      console.error("Erreur chargement clients :", error);
    }
  };


  // Ouvrir formulaire pour ajout
  const handleOpenAdd = () => {
    setClientEdit(null);
    setFormOpen(true);
  };


  // Ouvrir formulaire pour modification
  const onEdit = (client) => {
    setClientEdit(client);
    setFormOpen(true);
  };


  // Supprimer un client
  const onDelete = async (id) => {

    if (window.confirm("Voulez-vous supprimer ce client ?")) {

      try {

        await deleteClient(id);

        await loadClients();

      } catch (error) {

        console.error("Erreur suppression client :", error);

      }

    }
  };


  // Ajouter ou modifier un client
  const onSubmit = async (data) => {

    try {

      if (clientEdit) {

        // Modification
        await updateClient(clientEdit.id, data);

      } else {

        // Création
        await createClient(data);

      }


      // Actualiser la liste
      await loadClients();


      // Fermer le formulaire
      setFormOpen(false);


      // Nettoyer le mode édition
      setClientEdit(null);


    } catch (error) {

      console.error(
        "Erreur lors de l'enregistrement client :",
        error
      );

    }

  };


  // Fermer formulaire
  const handleCloseForm = () => {

    setFormOpen(false);

    setClientEdit(null);

  };


  return (
    <div className="clients-page">

      <h1>Gestion des Clients</h1>


      <button
        onClick={handleOpenAdd}
        className="btn-add"
      >
        + Ajouter un client
      </button>



      {formOpen && (

        <div className="form-container open">

          <ClientForm
            onSubmit={onSubmit}
            client={clientEdit}
          />


          <button
            onClick={handleCloseForm}
            className="btn-close"
          >
            Fermer
          </button>


        </div>

      )}



      <ClientTable

        clients={clients}

        onEdit={onEdit}

        onDelete={onDelete}

      />


    </div>
  );
}